import { deleteAiAgent } from '@api';
import { getCoreAiAgentSlice } from './get';

import { createDeleteAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const deleteCoreAiAgentSlice = createDeleteAsyncSlice({
	httpSagaOptions: {
		successActionCreators: [ getCoreAiAgentSlice.asyncActionCreators.requestGetCoreAiAgent ]
	},
	name: 'coreAiAgent',
	receive: false,
	request: true,
	requestHandler: deleteAiAgent,
	yieldType: SagaYieldType.Every
});
